import {Dispatch, PropsWithChildren, useMemo} from "react";
import {
  createSubscriptionReducer,
  initialCreateSubscriptionState,
} from "../../reducers/create-subscription";
import {createContext} from "../../../../../context/create-context";
import {
  CreateSubscriptionActions,
  CreateSubscriptionState,
} from "../../reducers/create-subscription/types";
import {
  OFFERING_CREATE_DRAFT_KEYS,
  usePersistedReducer,
} from "../../../../../utils/offering-create-draft";
import {useGetProfileContext} from "../../../../../context/profile/profile-context";

type CreateSubscriptionContextState = {
  state: CreateSubscriptionState;
  dispatch: Dispatch<CreateSubscriptionActions>;
  wasDraftRestored: boolean;
};

const [useContext, ContextProvider] = createContext<CreateSubscriptionContextState>();

export const useCreateSubscriptionContext = useContext;

export const CreateSubscriptionProvider = ({children}: PropsWithChildren) => {
  const {state: profileState} = useGetProfileContext();
  const draftScope = useMemo(
    () => ({
      draftKey: OFFERING_CREATE_DRAFT_KEYS.subscription,
      email: profileState.profileData.email,
    }),
    [profileState.profileData.email]
  );

  const [state, dispatch, {wasDraftRestored}] = usePersistedReducer(
    createSubscriptionReducer,
    draftScope,
    () => initialCreateSubscriptionState
  );
  const value = useMemo(
    () => ({state, dispatch, wasDraftRestored}),
    [state, wasDraftRestored]
  );

  return <ContextProvider value={value}>{children}</ContextProvider>;
};
